import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormDateField from 'modules/ui/editform/fields/EditFormDateField';
import VizsgazoEditService from '../service/VizsgazoEditService';

const config = {
	key: 'vizsgazoEditForm',
	text: 'Vizsgázó',
	textKey: 'vizsgazo',
	service: VizsgazoEditService,
	watchTitleKey: 'azonosito',
	fields: [
		{
			key: 'vizsgaHelyeVizsgazo',
			text: 'Vizsga helye',
			textKey: 'vizsgaHelyeVizsgazo',
			component: EditFormSelectField,
			items: () => VizsgazoEditService.getVizsgaHelyeSelection(),
			required: true,
			readOnly: true
		},
		{
			key: 'vizsgaVizsgazo',
			text: 'Vizsga',
			textKey: 'vizsgaVizsgazo',
			component: EditFormSelectField,
			items: () => VizsgazoEditService.getVizsgaSelection(),
			required: true,
			readOnly: true
		},
		{
			key: 'vezeteknev',
			text: 'Vezetéknév',
			textKey: 'vezeteknev',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'keresztnev',
			text: 'Keresztnév',
			textKey: 'keresztnev',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'pontszam',
			text: 'Pontszám',
			textKey: 'pontszam',
			component: EditFormTextField,
			type: 'number',
			required: true,
			readOnly: true
		},
		{
			key: 'erdemjegy',
			text: 'Érdemjegy',
			textKey: 'erdemjegy',
			component: EditFormTextField,
			type: 'number',
			required: true,
			readOnly: true
		},
		{
			key: 'azonosito',
			text: 'Azonosító',
			textKey: 'azonosito',
			component: EditFormTextField,
			required: true,
			readOnly: true
		},
		{
			key: 'jelszo',
			text: 'Jelszó',
			textKey: 'jelszo',
			component: EditFormTextField,
			required: true,
			readOnly: true
		},
		{
			key: 'bornDate',
			text: 'Születési dátum',
			textKey: 'bornDate',
			component: EditFormDateField,
			required: true,
			readOnly: true
		},
		{
			key: 'mothersName',
			text: 'Anyja neve',
			textKey: 'mothersName',
			component: EditFormTextField,
			required: true,
			readOnly: true
		}
	]
};

function VizsgazoEditForm() {
	return <EditFormPage config={config} />;
}

export default VizsgazoEditForm;
